import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-issues',
  templateUrl: './order-issues.component.html',
  styleUrls: ['./order-issues.component.scss'],
})
export class OrderIssuesComponent implements OnInit {

  @Input() isModal: boolean;

  constructor() { }

  ngOnInit() {}

}
